import './axiosSetup';  // MUST come before any component code
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n'; // Import i18n configuration
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadConfig } from './utils/config';

// Initialize the app with configuration
async function initializeApp() {
  try {
    // Load configuration from backend
    await loadConfig();
    
    // Create the root React element
    const root = ReactDOM.createRoot(document.getElementById('root'));
    
    // Render the app
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);
    // Render a minimal error state
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<div>Failed to load application. Please try again later.</div>);
  }
}

// Start the application
initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 